import { AutogenLayoutOfficeRecurringPayAdjustmentList } from "./autogen/AutogenLayoutOfficeRecurringPayAdjustmentList";
import { Component, Label, TableRowDisplayEvent } from "@mcleod/components";
import { DisplayType, ModelRow, UrlUtil } from "@mcleod/core";

export class OfficeRecurringPayAdjustmentList extends AutogenLayoutOfficeRecurringPayAdjustmentList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "payee_id", sort: "asc" }, { field: "deduct_code_id", sort: "asc" }];
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProp) {
            this.mainDataSource.search({
                payee_id: urlProp.payeeId,
                cutoff_date: urlProp.cutoffDate,
                currency: urlProp.currency,
                ready_to_pay_flag: "Y || N"
            }, null, this.layoutName);
        } else {
            this.mainDataSource.search(null, null, this.layoutName);
        }
    }

    tableOfficeRecuringPayAdjustmentsOnRowDisplay(event: TableRowDisplayEvent): void {
        const tableRow = event.getTableRow();
        tableRow.forEveryChildComponent((component) => {
            this.setTooltipContent(component, tableRow.data);
        });
    }

    setTooltipContent(component: Component, modelRow: ModelRow) {
        if (component instanceof Label && component.displayType === DisplayType.STRING) {
            component.tooltip = modelRow.get(component.field);
        }
    }
}
